// import { FlowDefineSimpleEditor } from '@oppein/bpmn-component'
export const storeManager = [
  {
    //我的商场
    path: 'store',
    name: 'Store',
    component: () => import('@/page/main/store/index'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
      ],
    },
  },
  {
    //门店流程申请单
    path: 'storeFlowTaskList',
    name: 'storeFlowTaskList',
    component: () => import('@/page/main/store/flow/taskList.vue'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '门店流程申请单', path: '/main/storeFlowTaskList' },
      ],
    },
  },
  {
    path: 'storeDetail',
    name: 'StoreDetail',
    component: () => import('@/page/main/store/detail'),
    meta: {
      keepAlive: false,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '门店详情', path: '/main/storeDetail' },
      ],
    },
  },
  {
    path: 'storeFlowConfig',
    name: 'storeFlowConfig',
    component: () => import('@/page/main/store/flow/flowConfigList.vue'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店配置管理', path: '/main/storeConfig' },
        { title: '流程配置', path: '/main/flowConfig' },
      ],
    },
  },
  {
    path: 'openStatusFlowForm/:action',
    name: 'openStatusFlowForm',
    component: () => import('@/page/main/store/flow/closedStatusFlowForm'),
    meta: {
      keepAlive: false,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '恢复门店流程申请', path: '/main/openStatusFlowForm/open' },
      ],
    },
  },
  {
    path: 'closedStatusFlowForm/:action',
    name: 'closedStatusFlowForm',
    component: () => import('@/page/main/store/flow/closedStatusFlowForm'),
    meta: {
      keepAlive: false,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '关闭门店流程申请', path: '/main/closedStatusFlowForm/close' },
      ],
    },
  },
  {
    path: 'storeConfig',
    name: 'storeConfig',
    component: () => import('@/page/main/store/formConfig/list.vue'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店配置管理', path: '/main/storeConfig' },
      ],
    },
  },
  {
    path: 'flowDefineEditor',
    name: 'flowDefineEditor',
    component: () => import('@/page/main/store/flow/flowDefineSimpleEditor.vue'),
    meta: {
      keepAlive: false,
      router: [
        { title: '首页', path: '/main/home' },
        // { title: '门店配置管理', path: '/main/storeConfig' },
        { title: '流程配置', path: '/main/flowConfig' },
        { title: '流程编辑', path: '/main/flowDefineEditor' },
      ],
    },
  },
  {
    path: 'storeFormConfigList',
    name: 'storeFormConfigList',
    component: () => import('@/page/main/store/formConfig/list.vue'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店配置管理', path: '/main/storeConfig' },
        { title: '表单基础配置', path: '/main/storeFormConfigList' },
      ],
    },
  },
  {
    path: 'storeFormConfigDetail',
    name: 'storeFormConfigDetail',
    component: () => import('@/page/main/store/formConfig/detail.vue'),
    meta: {
      keepAlive: false,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '表单基础配置', path: '/main/storeFormConfigList' },
        { title: '表单基础配置详情', path: '/main/storeFormConfigDetail' },
      ],
    },
  },
]

export const ExternalStoreManager = [
  {
    //我的商场
    path: '/external/store',
    name: 'ExternalStore',
    component: () => import('@/page/main/store/index'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
      ],
      white: true,
    },
  },
  {
    //门店流程申请单
    path: '/external/storeFlowTaskList',
    name: 'ExternalStoreFlowTaskList',
    component: () => import('@/page/main/store/flow/taskList.vue'),
    meta: {
      keepAlive: true,
      white: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '门店流程申请单', path: '/main/storeFlowTaskList' },
      ],
    },
  },
  {
    path: '/external/storeDetail',
    name: 'ExternalStoreDetail',
    component: () => import('@/page/main/store/detail'),
    meta: {
      keepAlive: false,
      white: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '门店详情', path: '/main/storeDetail' },
      ],
    },
  },
  {
    path: '/external/openStatusFlowForm/:action',
    name: 'ExternalOpenStatusFlowForm',
    component: () => import('@/page/main/store/flow/closedStatusFlowForm'),
    meta: {
      keepAlive: false,
      white: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '恢复门店流程申请', path: '/main/openStatusFlowForm/open' },
      ],
    },
  },
  {
    path: '/external/closedStatusFlowForm/:action',
    name: 'ExternalClosedStatusFlowForm',
    component: () => import('@/page/main/store/flow/closedStatusFlowForm'),
    meta: {
      keepAlive: false,
      white: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '门店管理', path: '/main/store' },
        { title: '关闭门店流程申请', path: '/main/closedStatusFlowForm/close' },
      ],
    },
  },
  {
    name: 'ExternalFlowTask',
    path: '/external/flowCenter/task',
    meta: {
      name: '审核',
      white: true,
    },
    component: () => import('@/page/main/flowCenter/task'),
  },
  {
    name: 'ExternalFlowInst',
    path: '/external/flowCenter/flowInst',
    meta: {
      name: '实例',
      white: true,
    },
    component: () => import('@/page/main/flowCenter/inst'),
  },
]
